import { useState } from "react";
import { Container, Navbar, Dropdown, Nav, Button } from "react-bootstrap";
import Logo from '../../assets/images/logo-horizontal.svg'
import { Link } from "react-router-dom";
import IconPos from '../../assets/images/menu-icon/icon-pos.svg'
import IconInventory from '../../assets/images/menu-icon/icon-Inventory.svg'
import { RiLogoutBoxRLine, RiMenuUnfoldLine } from "react-icons/ri";
import MobileLogo from "../../assets/images/logo-verticle.svg"
import CommonSearch from "../Common/CommonSearch";
import { useMenu, MenuKeys } from "../../context/MenuContext";
import IconDashboard from "../../assets/images/menu-icon/icon-dashboard.svg"
import WebService from "../../Services/WebService";
import ConfirmationModal from "../Common/Modals/ConfirmationModal";
import { DashboardTabs } from "../../POS/Enums/POSEnums";
import { useDispatch } from "react-redux";
import { resetState } from "../../Redux/action";

const ModuleNav = () => {
    const { selectedMenuKey, setSelectedMenuKey } = useMenu();


    const handleMenuClick = (menuKey: MenuKeys) => {
        localStorage.setItem("dashboard_tab_seletced", DashboardTabs.TAB_TAKE_AWAY)
        setSelectedMenuKey(menuKey);
    };

    return (
        <>
            <Nav className="module-nav">
                <Link
                    to="/pos/dashboard"
                    className={`nav-link ${selectedMenuKey === MenuKeys.POS ? 'active' : ''}`}
                    onClick={() => handleMenuClick(MenuKeys.POS)}
                >
                    <img src={IconDashboard} className="menu-icon" alt="icon" /> Dashboard
                </Link>
                <Link
                    to="/pos/kds"
                    className={`nav-link ${selectedMenuKey === MenuKeys.KDS ? 'active' : ''}`}
                    onClick={() => handleMenuClick(MenuKeys.POS)}
                >
                    <img src={IconPos} className="menu-icon" alt="icon" /> KDS
                </Link>

            </Nav>
        </>
    )
}

const Header = () => {
    const { selectedMenuKey } = useMenu();
    const [showLogout, setShowLogout] = useState(false);
    // Toggle body class for mobile menu
    const [menuOpen, setMenuOpen] = useState(false);
    let dispatch = useDispatch();
    const handleMenuToggle = () => {
        document.body.classList.toggle('show-mo-menu');
        setMenuOpen((prev: boolean) => !prev);
    };

    const getActiveModuleInfo = () => {
        switch (selectedMenuKey) {
            case MenuKeys.POS:
                return { icon: IconPos, text: 'Dashboard' };
            case MenuKeys.KDS:
                return { icon: IconInventory, text: 'KDS' };

            default:
                return { icon: IconPos, text: 'POS' };
        }
    };
    const handleLogout = () => {
        dispatch(resetState())
        WebService.logout()
        setShowLogout(false);
    };

    const activeModule = getActiveModuleInfo();
    return (
        <>
            <header className="site-header">
                <Container fluid className='header-nav'>
                    <Navbar>
                        <a
                            href="javascript:void(0);"
                            className={`text-primary-2 d-lg-none mo-menu-toggle${menuOpen ? ' mo-menu-open' : ''}`}
                            onClick={handleMenuToggle}
                        >
                            <RiMenuUnfoldLine size="24" />
                        </a>
                        <Navbar.Brand className="">
                            <img src={Logo} width={193} height={32} alt='Logo' className=" align-text-top d-none d-lg-block" />
                            <img src={MobileLogo} width={80} alt='Logo' className=" align-text-top d-lg-none d-block" />
                        </Navbar.Brand>
                        <div className="d-block d-lg-none ms-auto">
                            <Dropdown className="module-dd" align="end" autoClose='outside'>
                                <Dropdown.Toggle variant="" id="dropdown-basic">
                                    <img src={activeModule.icon} className="menu-icon" alt="icon" /> {activeModule.text}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <ModuleNav />
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div className="d-none d-lg-block">
                            <ModuleNav />
                        </div>
                        <div className="d-none d-lg-block text-end ms-auto gap-3 col-lg-3">
                            <div className="w-100 d-flex justify-content-end">
                                <Button
                                    title="Logout"
                                    className='toggle-menu-btn btn'
                                    variant="outline-danger2"
                                    onClick={() => setShowLogout(true)}
                                    style={{ width: "45px", height: "45px" }}
                                >
                                    <RiLogoutBoxRLine size={24} />
                                </Button>
                                {/* <CommonSearch /> */}
                            </div>
                        </div>
                    </Navbar>
                </Container>
            </header>
            {showLogout &&
                <ConfirmationModal
                    show={showLogout}
                    setShow={setShowLogout}
                    heading="Logout"
                    message="Are you sure you want to logout?"
                    handleYesClick={handleLogout}
                />}
        </>
    )
}
export default Header;